<template lang="pug">
.is-flex.is-flex-direction-row.signin-container
  
  section.p-6.is-flex-grow-1.is-flex.is-flex-direction-column(style="overflow: scroll")
    .pb-3
      a(:href="`https://www.emly.${rootDomain}`" target="_blank")  
        img(src="../../../assets/logo_black.svg", style="height:36px;")
    .is-flex-grow-1.is-flex.is-align-items-center
      .columns.is-centered.is-flex-grow-1
        .column.is-8-desktop.is-10-tablet.is-12-mobile
          em-loading(:active="submitting" :is-full-page="true")
          div  
            h1.title.is-3(v-t="'signup.create_business_title'")
            p.subtitle.has-text-grey.is-6(v-t="'signup.create_business_subtitle'")
            form(@submit.prevent="selectPlan")
              b-field(:label="$t('signup.business_name_label')", :type="errors.has('name') ? 'is-danger': ''" :message="errors.has('name') ? errors.first('name') : ''")
                b-input(v-model="name" ref="companyNameInput" icon="store" v-validate="'required'" name="name" :placeholder="$t('signup.business_name_placeholder')" data-vv-as="business name" expanded)
              b-field(:label="$t('signup.industry_label')" :type="errors.has('industry') ? 'is-danger': ''" :message="errors.has('industry') ? errors.first('industry') : ''")
                b-select(v-model="industry" name="industry" v-validate="'required'" :placeholder="$t('signup.industry_placeholder')" data-vv-as="industry" expanded)
                  option(v-for="ind in industries" :value="ind") {{ $t(`industries.${ind}`) }}
              b-field(v-if="industry === 'other'" :label="$t('signup.other_industry_label')", :type="errors.has('otherIndustry') ? 'is-danger': ''" :message="errors.has('otherIndustry') ? errors.first('otherIndustry') : ''")
                b-input(v-model="otherIndustry"  v-validate="'required'" name="otherIndustry" :placeholder="$t('signup.other_industry_placeholder')" data-vv-as="industry" expanded)
              b-field(:label="$t('signup.country_label')" :type="errors.has('country') ? 'is-danger': ''" :message="errors.has('country') ? errors.first('country') : ''" expanded)
                CountrySelect(v-model="country" data-vv-as="country" name="country" v-validate="'required'" expanded)
              
              b-field(:label="$t('signup.timezone_label')" :type="errors.has('timezone') ? 'is-danger': ''" :message="errors.has('timezone') ? errors.first('timezone') : ''" expanded)
                TimezoneSelect(v-model="timezone" data-vv-as="timezone" name="timezone" v-validate="'required'" expanded)

              b-field(:label="$t('signup.currency_label')", :type="errors.has('currency') ? 'is-danger': ''" :message="errors.has('currency') ? errors.first('currency') : ''" expanded)
                CurrencySelect(v-model="currency" :placeholder="$t('signup.currency_placeholder')" name="currency" v-validate="'required'" data-vv-as="currency" expanded)
              .buttons.is-centered
                  action-button.is-primary.is-fullwidth.is-medium(@click="selectPlan"  title="actions.next" :loading="loading")
      
        
  section.p-6.signin-cover.is-flex-grow-1.is-hidden-touch.is-clipped(:style="{'background-image': `url('${bgImage}')`}") 
    div
      .p-6

        //h2.title.is-2.has-text-white(style="line-height: 1.25em") Rise above competition
        transition-group(name="list" tag="ul")
          li.mb-6(v-for="q in quotes" :key="q.title") 
            h3.title.is-3.has-text-white {{ q.title }}
            p.subtitle.has-text-white {{ q.subtitle }}
        
    
      

</template>
<script>
const images = [
  'https://images.pexels.com/photos/2104499/pexels-photo-2104499.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/6331049/pexels-photo-6331049.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/3293037/pexels-photo-3293037.jpeg?auto=compress&cs=tinysrgb&w=1600'
]

import {mapActions} from 'vuex'
import INDUSTRIES from '../../../../constants/industries'
import {PRODUCTS} from '../../../../constants/products'
import TIPS from '../../../../constants/businessTips'
import defaultConfigByCountry from '../../../../constants/defaultConfigByCountry'
import CurrencySelect from '../../shared/CurrencySelect'
import TimezoneSelect from '../../shared/TimezoneSelect'
import CountrySelect from '../../shared/CountrySelect'
import Pricing from '../../billing/Pricing'
export default {
  name: 'BusinessSetup',
  components: {
    TimezoneSelect,
    CurrencySelect,
    CountrySelect
  },
  data() {
    return {
      submitting: false,
      loading: false,
      counter: 0,
      name: undefined,
      timezone: undefined,
      currency: undefined,
      country: undefined,
      industries: Object.values(INDUSTRIES),
      industry: undefined,
      otherIndustry: undefined,
      timeFormat: undefined,
      weekStart: undefined,
      quotes: []
    }
  },
  computed: {
    bgImage() {
      return images[parseInt(Math.random() * images.length)]
    },
    messages() {
      return TIPS[this.$i18n.locale] || TIPS.en
    },
    rootDomain() {
      return window.location.hostname.split('.').pop()
    }
  },
  created() {
    this.guessSettings()

    setInterval(() => {
      if (this.quotes.length >= Math.round((window.innerHeight - 200) / 125)) {
        this.quotes = []
      }
      if (this.counter === this.messages.length) {
        this.counter = 0
      }
      this.quotes.push(this.messages[this.counter])
      this.counter++
    }, 3000)
  },
  mounted() {
    this.$refs.companyNameInput.focus()
  },
  methods: {
    ...mapActions('auth', ['createBusiness']),

    async guessSettings() {
      try {
        let geoData = await this.$http.get('https://ip2c.org/s').then(res => res.body)

        if (geoData) {
          this.country = geoData.split(';')[1]
        }
      } catch (err) {
        console.log('failed fetching country')
      }
      if (!this.country) {
        this.country = this.rootDomain === 'co' ? 'AU' : 'AM'
      }
      const config = defaultConfigByCountry[this.country] || defaultConfigByCountry.default
      this.currency = config.currency
      this.timeFormat = config.timeFormat
      this.weekStart = config.weekStart
    },

    async selectPlan() {
      if (this.loading) {
        return
      }
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      if (this.country === 'AM') {
        return this.submit({plan: PRODUCTS.RF_PROFESSIONAL, billingCycle: 'monthly'})
      }

      this.$buefy.modal.open({
        parent: this,
        component: Pricing,
        hasModalCard: true,
        fullScreen: true,
        canCancel: [],
        props: {
          country: this.country,
          industry: this.industry
        },
        events: {
          input: ({plan, billingCycle}) => {
            this.submit({plan, billingCycle})
          }
        }
      })
    },

    async submit({plan, billingCycle}) {
      const valid = await this.$validator.validateAll()
      if (!valid || this.submitting) {
        return
      }
      this.submitting = true
      try {
        await this.createBusiness({
          name: this.name,
          timezone: this.timezone,
          currency: this.currency,
          plan,
          billingCycle,
          country: this.country,
          industry: this.industry,
          otherIndustry: this.industry === INDUSTRIES.OTHER ? this.otherIndustry : undefined
        })
        this.$router.push('/calendar')
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.submitting = false
    }
  }
}
</script>
<style scoped>
.signin-container section {
  flex-basis: 0;
}

.signin-cover {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}
</style>
<style>
.list-enter-active {
  transition: all 1s;
}
.list-leave-active {
  transition: all 100ms;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
